// core
import {Injectable} from '@angular/core';
// models
import {
  StatusColors,
  StatusesFromServer,
  StatusesToButtonView,
  StatusesToOrderView
} from '../../../core/models/order.model';
// store
import {OrderStore} from '../../../core/stores/order.store';

@Injectable()
export class OrdersStatusService {

  constructor(private orderStore: OrderStore) {
  }

  public replacementStatus(statusForReplace: string): string {
    const index = StatusesFromServer.indexOf(statusForReplace);
    if (index === -1) {
      throw new Error(`Incorrect status ${statusForReplace}`);
    }
    return StatusesToOrderView[index];
  }

  public replacementStatusForActionButton(statusForReplace: string): string {
    const index = StatusesFromServer.indexOf(statusForReplace);
    if (index === -1) {
      throw new Error(`Incorrect status ${statusForReplace}`);
    }
    return StatusesToButtonView[index];
  }

  public updateOrderStatus(statusForUpdate: string, locationId: string, orderId: string): void {
    const lastStatus = StatusesFromServer[StatusesFromServer.length - 1];
    const index = StatusesFromServer.indexOf(statusForUpdate);

    if (index === -1) {
      throw new Error(`Incorrect status ${statusForUpdate}`);
    }

    if (statusForUpdate === lastStatus) {
      this.orderStore.archiveOrder(statusForUpdate, orderId);
    } else {
      const status = StatusesFromServer[index + 1];
      this.orderStore.updateOrderStatus(status, locationId, orderId);
    }
  }

  public addColorToStatus(currentStatus: string): string {
    for (status in StatusColors) {
      if (status === currentStatus && StatusColors.hasOwnProperty(status)) {
        return StatusColors[status];
      }
    }
  }
}
